// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout {
  min-height: 100vh;
  background: transparent !important; /* 让背景透明以显示粒子 */
}

.skill-card {
  height: 100%;
  border-radius: 12px !important;
  overflow: hidden;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(5px);
}

.skill-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
}

.skill-card .ant-card-head {
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .site-layout-content {
    padding: 12px;
  }
  
  .ant-layout-content {
    padding: 0 12px !important;
  }
  
  .section-profile {
    margin-top: 20px !important;
  }
}

/* 平滑滚动 */
html {
  scroll-behavior: smooth;
}

/* 统计卡片样式 */
.ant-statistic-title {
  font-size: 16px;
  margin-bottom: 8px;
}

.ant-statistic-content {
  font-size: 28px;
  font-weight: bold;
  color: #1890ff;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kCAAkC,EAAE,eAAe;AACrD;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,+CAA+C;EAC/C,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,UAAU;AACV;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,SAAS;AACT;EACE,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".layout {\r\n  min-height: 100vh;\r\n  background: transparent !important; /* 让背景透明以显示粒子 */\r\n}\r\n\r\n.skill-card {\r\n  height: 100%;\r\n  border-radius: 12px !important;\r\n  overflow: hidden;\r\n  transition: all 0.3s ease;\r\n  background: rgba(255, 255, 255, 0.9) !important;\r\n  backdrop-filter: blur(5px);\r\n}\r\n\r\n.skill-card:hover {\r\n  transform: translateY(-5px);\r\n  box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;\r\n}\r\n\r\n.skill-card .ant-card-head {\r\n  text-align: center;\r\n  border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n/* 响应式调整 */\r\n@media (max-width: 768px) {\r\n  .site-layout-content {\r\n    padding: 12px;\r\n  }\r\n  \r\n  .ant-layout-content {\r\n    padding: 0 12px !important;\r\n  }\r\n  \r\n  .section-profile {\r\n    margin-top: 20px !important;\r\n  }\r\n}\r\n\r\n/* 平滑滚动 */\r\nhtml {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\n/* 统计卡片样式 */\r\n.ant-statistic-title {\r\n  font-size: 16px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.ant-statistic-content {\r\n  font-size: 28px;\r\n  font-weight: bold;\r\n  color: #1890ff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
